export class ModelEnergy {
	code: string;
	name: string;
	isCommercialized: boolean;
	subrangeId: number | null;
}
